import { HTMLAttributes, useState } from "react";
import { format } from "date-fns";
import { CalendarIcon } from "lucide-react";
import { Button } from "@/components/button";
import { Calendar } from "@/components/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/popover";
import { cn } from "@/lib/utils";

interface DatePickerProps extends HTMLAttributes<HTMLDivElement> {
  date: Date | undefined;
  setDate: (date: Date) => void;
  minDate?: Date;
  maxDate?: Date;
  closeOnSelect?: boolean;
  formatStr?: string;
  disabled?: boolean;
  popoverClassName?: string;
}
export const DatePicker = (props: DatePickerProps) => {
  const {
    date,
    setDate,
    closeOnSelect,
    minDate,
    maxDate,
    formatStr = "PPP",
    disabled,
    popoverClassName,
    ...rest
  } = props;

  const [isOpen, setIsOpen] = useState(false);
  return (
    <Popover open={isOpen} onOpenChange={setIsOpen}>
      <PopoverTrigger asChild>
        <Button
          type="button"
          size={"sm"}
          variant={"outline"}
          disabled={disabled}
          className={cn(
            "w-[240px] justify-start text-left font-normal",
            !date && "text-muted-foreground",
            rest.className
          )}
        >
          <CalendarIcon />
          {date ? format(date, formatStr) : <span>Pick a date</span>}
        </Button>
      </PopoverTrigger>
      <PopoverContent className={cn("w-auto p-0", popoverClassName)}>
        <Calendar
          disabled={(date) =>
            (minDate && date < minDate) || (maxDate && date > maxDate) || false
          }
          defaultMonth={date}
          mode="single"
          selected={date}
          onSelect={(d) => {
            if (d) setDate(d);
            closeOnSelect && setIsOpen(false);
          }}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
};
